import { combineReducers } from 'redux'

import account from './Account'
import clanManagement from './ClanManagement'
import dialog from './Dialog'
import fetching from './Fetching'
import members from './Members'
import membersOperation from './MembersOperation'
import realm from './Realm'

export const reducers = {
    account,
    clanManagement,
    dialog,
    fetching,
    members,
    membersOperation,
    realm,
}

export default combineReducers(reducers)



// WEBPACK FOOTER //
// ./state/reducers/CMT/index.js